<div *ngIf="languaje === 'en'">
  <li class="pill" [ngClass]="{'active': is_active}">
    <a [href]="uriHomeEn" target="_blank" class="icon-splash_abanca">Miles Terms of Use</a>
  </li>

  <a [href]="uriHomeEn" target="_blank" class="icon-splash_abanca pill-mobile"
    [ngClass]="{'active': show_mobile}">Miles Terms of Use</a>
</div>



<div *ngIf="languaje === 'es'">
  <li class="pill" [ngClass]="{'active': is_active}">
    <a [href]="uriHomeEs" target="_blank" class="icon-splash_abanca">Miles Términos y Condiciones</a>
  </li>

  <a [href]="uriHomeEs" target="_blank" class="icon-splash_abanca pill-mobile"
    [ngClass]="{'active': show_mobile}">Miles Términos y Condiciones</a>
</div>
